export const SET_POST_BOOSTING_RULES = 'setPostBoostingRules'
